export namespace EnrollmentRestriction {
  export class Enum {
    static readonly ONGOING = new Enum(1, 'ONGOING')

    static readonly WAITING = new Enum(2, 'WAITING')

    static readonly CANCELED = new Enum(3, 'CANCELED')

    static readonly OUT_OF_PLAN_SCOPE = new Enum(4, 'OUT_OF_PLAN_SCOPE')

    static readonly INACTIVE = new Enum(5, 'INACTIVE')

    static readonly COMPANY_BLOCKED = new Enum(6, 'COMPANY_BLOCKED')

    static readonly INSTITUTION_ENROLLMENT_BLOCK = new Enum(7, 'INSTITUTION_ENROLLMENT_BLOCK')

    static readonly CATEGORY_ENROLLMENT_BLOCK = new Enum(8, 'CATEGORY_ENROLLMENT_BLOCK')

    private constructor(
      public readonly id: number,
      public readonly name: string
    ) {}
  }

  export const getByName = (name: string | null): Enum => {
    return Object.values(EnrollmentRestriction.Enum).find(restriction => restriction.name === name)
  }
}
